export default "__VITE_ASSET__qK4HggWD__"